// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_OFA","cls2":"Unibrow-cls2_ALO Unibrow-cls1_OFA"};